/**
 * @generated SignedSource<<d805b55541ae6d7966bf7da11af316d5>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useDeetCriteria_query$data = {
  readonly currentUser: {
    readonly deetCriteria: {
      readonly nodes: ReadonlyArray<{
        readonly deetId: any;
      } | null | undefined>;
    };
  } | null | undefined;
  readonly " $fragmentType": "useDeetCriteria_query";
};
export type useDeetCriteria_query$key = {
  readonly " $data"?: useDeetCriteria_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"useDeetCriteria_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useDeetCriteria_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "currentUser",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "orderBy",
              "value": [
                "DEET_BY_DEET_ID__SEQUENCE_ASC"
              ]
            }
          ],
          "concreteType": "DeetCriterionConnection",
          "kind": "LinkedField",
          "name": "deetCriteria",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "DeetCriterion",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "deetId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "deetCriteria(orderBy:[\"DEET_BY_DEET_ID__SEQUENCE_ASC\"])"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "9ab8a502ffafc785bddc5eee2e20a2b7";

export default node;
